'use strict';

function dataRequestService ($q, $resource, $http, urlFactory) {
  const makeDataRequest = function(requestObject) {
    return $resource(requestObject.url, requestObject.object, {
      doRequest: {
        method:  requestObject.method,
        isArray: requestObject.isAnArray,
        headers: { 'Accept': '*/*' }
      }
    });
  };

  const makeDataRequestbytes = function(url, filters) {

    return $http({
		method: 'POST',
		url: url,
		data: filters,                 
		responseType: 'arraybuffer',    
		headers: {
			'Content-Type': 'application/json'
		}
	});
  };

  const getDataRequestbytes = function(url) {

    return $http({
		method: 'GET',
		url: url,              
		responseType: 'arraybuffer',    
	});
  };

  this.getFiltersData = function() {
		return makeDataRequest({
			url: urlFactory.getUrl('FILTERS'),
			object: {},
			method: 'GET',
			isAnArray: false
		}).doRequest().$promise;
	};

	this.getAppConfiguration = function(dns) {
		return makeDataRequest({
			url: urlFactory.getDirectUrl('CONFIGURATION'),
			object: {dns: dns},
			method: 'GET',
			isAnArray: false
		}).doRequest().$promise;
	};

	this.getContractsData = function(filters) {
		return makeDataRequest({
			url: urlFactory.getUrl('CONTRACTS'),
			object: {},
			method: 'POST',
			isAnArray: true
		}).doRequest(filters).$promise;
	};

	this.getContractsReportData = function(filters) {		
		return makeDataRequestbytes(urlFactory.getUrl('CONTRACTS_REPORT'), filters);
	};

	this.getContractReportData = function(contractId) {		
		return getDataRequestbytes(urlFactory.getUrl('CONTRACT_REPORT') + contractId);
	};

	this.getContractDetails = function(contractId) {
		return makeDataRequest({
			url: urlFactory.getUrl('CONTRACT_DETAILS'),
			object: {contractId: contractId},
			method: 'GET',
			isAnArray: false
		}).doRequest({}).$promise;
	};

	this.getConstructionSiteSupervisors = function(contractId, siteId) {
	 	return makeDataRequest({
	 		url: urlFactory.getUrl('SUPERVISORS'),
			object: {contractId: contractId, siteId: siteId},
			method: 'GET',
			isAnArray: true
	 	}).doRequest().$promise;
	};

    this.getEdict = function(contractId) {
      return makeDataRequest({
        url: urlFactory.getUrl('EDITAL'), object: {contractId: contractId}, method: 'GET', isAnArray: false
      }).doRequest().$promise;
    };

    this.getLicensesEnvironmental = function(contractId) {
      return makeDataRequest({
        url: urlFactory.getUrl('LICENCAAMBIENTAL'), object: {contractId: contractId}, method: 'GET', isAnArray: true
      }).doRequest().$promise;
    };

		this.getHeatMapPoints = function(context) {
			return makeDataRequest({
				url: urlFactory.getUrl('HEAT_MAP'), object: {context: context}, method: 'GET', isAnArray: true
			}).doRequest({}).$promise;
		};

	this.sendEmail = function(email) {
		return makeDataRequest({
			url: urlFactory.getUrl('EMAIL'),
			object: {},
			method: 'POST',
			isAnArray: false
		}).doRequest(email).$promise;""
	};

    this.getParameterByName = function(nmParameter,cdSystem) {
		return makeDataRequest({
			url: urlFactory.getUrl('PARAMETER_BY_NAME'),
			object: {cdSystem: cdSystem,nmParameter: nmParameter},
			method: 'GET',
			isAnArray: false
		}).doRequest({}).$promise;
    };

    this.getParameters = function(parameters,cdSystem) {
      return makeDataRequest({
        url: urlFactory.getUrl('GET_PARAMETERS'), object: {cdSystem: cdSystem,parameters: parameters}, method: 'GET', isAnArray: false
      }).doRequest({}).$promise;
		};

		this.getClientConfigJsonLocal = function(tenantId) {
			return makeDataRequest({
        url: urlFactory.getLocalJSON('CLIENT_CONFIG_LOCAL', tenantId), object: {}, method: 'GET', isAnArray: false
      }).doRequest({}).$promise;
		};

  this.getClientConfigJsonBancoDados = function() {
    return makeDataRequest({
      url:       urlFactory.getUrl('CLIENT_CONFIG_BD'),
      object:    {},
      method:    'GET',
      isAnArray: false
    }).doRequest({}).$promise;
  };


  this.getLabels = function() {
    return makeDataRequest({
      url:       urlFactory.getUrl('LABELS'),
      object:    {},
      method:    'GET',
      isAnArray: false
    }).doRequest({}).$promise;
  };

  this.getFavoriteFilters = function() {
    return $http.get(urlFactory.getUrl('FAVORITE_FILTERS'))
  };

	this.getFinancialSummary = function (contractId) {
		return makeDataRequest({
			url: urlFactory.getUrl('FINANCIAL_SUMMARY'),
			object: { contractId },
			method: 'GET',
			isAnArray: true
		}).doRequest({}).$promise
	};

  this.getCoordenadasUf = function(uf) {
    return makeDataRequest({
      url: urlFactory.getUrl('COORDENADAS_UF'),
      object: {uf: uf},
      method: 'GET',
      isAnArray: false
    }).doRequest({}).$promise;
  };

  this.getCoordenadasMunicipio = function(city) {
    return makeDataRequest({
      url: urlFactory.getUrl('COORDENADAS_MUNICIPIO'),
      object: {city: city},
      method: 'GET',
      isAnArray: false
    }).doRequest({}).$promise;
  };
}

dataRequestService.$inject = ['$q', '$resource', '$http', 'urlFactory'];
export default dataRequestService



// WEBPACK FOOTER //
// ./src/app/scripts/services/dataRequestService.js